import { CommonModule, Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'kon-error-page',
  standalone: true,
  imports: [CommonModule, ButtonModule, RouterLink],
  template: `
    <main
      class="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8"
    >
      <div class="text-center -mt-8">
        <p class="text-base font-semibold text-indigo-600">{{ code }}</p>
        <h1
          class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl"
        >
          {{ message }}
        </h1>
        <p class="mt-6 text-base leading-7 text-gray-600">
          {{ description }}
        </p>
        <div class="mt-10 flex items-center justify-center gap-x-6">
          <button pButton [routerLink]="['/']" [outlined]="true">Domov</button>
          <button pButton (click)="location.historyGo(-1)">Späť</button>
          <!-- <a href="#" class="text-sm font-semibold text-gray-900"
            >Contact support <span aria-hidden="true">&rarr;</span></a
          > -->
        </div>
      </div>
    </main>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
  @Input({ required: true }) code!: number | string;
  @Input({ required: true }) message!: string;
  @Input({ required: true }) description!: string;
  protected location = inject(Location);
}
